<template>
  <div v-if="asset != null" class="property-view">
    <!-- Property Header -->
    <div class="property-header" v-if="project">
      <div class="property-header-content">
        <!-- Project Logo -->
        <div class="property-logo" v-if="project.urlLogoProyecto">
          <img
            :src="setPhoto(project.urlLogoProyecto, project.urlLogoProyecto)"
            alt="Logo Proyecto"
          />
        </div>

        <!-- Property Info -->
        <div class="property-info">
          <h1 class="property-title">
            {{ asset.asset_type }} {{ asset.number }}
          </h1>
          <div class="property-location">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 21C12 21 19 15.5 19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10C5 15.5 12 21 12 21Z"
                stroke="currentColor"
                stroke-width="1.5"
              />
              <circle
                cx="12"
                cy="10"
                r="2"
                stroke="currentColor"
                stroke-width="1.5"
              />
            </svg>
            <span>{{ address }}</span>
          </div>
          <p class="property-address-country" v-if="addressCountry">
            {{ addressCountry }}
          </p>
        </div>
      </div>
    </div>

    <!-- Property Content with Tabs -->
    <options
      :asset_id="asset.asset_id"
      :project_id="asset.project_id"
      :tab_index="tab_index"
      :features="features"
      :photos="photos"
      :images="images"
    />
  </div>
</template>
<script>
import options from "./Options";
export default {
  name: "apartments",
  components: { options },
  props: {
    asset: { default: null },
    tab_index: { default: null },
    photos: { default: [] },
    images: { default: [] },
    features: { default: [] },
  },
  data() {
    return {
      selectedApartment: null,
      apartments: [],
    };
  },
  mounted() {},
  methods: {
    setPhoto(photo, photoComplete) {
      return "https://s3.amazonaws.com/gestion.mobysuite/" + photoComplete;
    },
  },
  computed: {
    domain() {
      return this.$store.getters.getCustomerDomain;
    },
    version() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
    project() {
      return this.asset
        ? this.$store.getters.getProjectByMoby(this.asset.project_id)
        : null;
    },
    address() {
      if (this.version == 1) {
        return this.project
          ? `${
              this.project.direccion.direccion
            }, ${this.project.direccion.comuna
              .toLowerCase()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
              .join(" ")}`
          : "";
      } else {
        return this.project
          ? `${this.project.direccion.calle}, ${this.project.direccion.municipio
              .toLowerCase()
              .split(" ")
              .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
              .join(" ")}`
          : "";
      }
    },
    addressCountry() {
      return this.project
        ? `${this.project.direccion.ciudad} ${this.project.direccion.pais}`
        : "";
    },
    country() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.country
        : 1;
    },
    template() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.template
        : "default";
    },
  },
};
</script>
<style scoped>
.property-view {
  max-width: 100%;
}

.property-header {
  margin-bottom: 24px;
  animation: headerFadeIn 0.4s ease;
}

@keyframes headerFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.property-header-content {
  display: flex;
  align-items: center;
  gap: 20px;
}

.property-logo {
  flex-shrink: 0;
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: logoScaleIn 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s backwards;
}

@keyframes logoScaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.property-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.property-info {
  flex: 1;
  min-width: 0;
  animation: infoSlideIn 0.4s ease 0.15s backwards;
}

@keyframes infoSlideIn {
  from {
    opacity: 0;
    transform: translateX(-15px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.property-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  text-transform: capitalize;
  line-height: 1.2;
}

.property-location {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #6b7280;
  font-size: 0.95rem;
}

.property-location svg {
  flex-shrink: 0;
  color: #9ca3af;
}

.property-address-country {
  margin: 4px 0 0 22px;
  font-size: 0.875rem;
  color: #9ca3af;
}

@media (max-width: 576px) {
  .property-header-content {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
  }

  .property-logo {
    width: 56px;
    height: 56px;
    border-radius: 10px;
  }

  .property-title {
    font-size: 1.125rem;
    margin-bottom: 4px;
  }

  .property-location {
    font-size: 0.8125rem;
  }

  .property-location svg {
    width: 14px;
    height: 14px;
  }

  .property-address-country {
    font-size: 0.75rem;
    margin: 2px 0 0 20px;
  }
}
</style>
